import { useEffect, useState } from 'react';
import { CountUp } from 'use-count-up'

import { FUNCTIONS_URL } from '../../../config/serverUrl'

import { className } from '../../../Utils'
import { easeOutExpo } from './PregnancyCounterHelpers'

import './PregnancyCounter.css'

const PregnancyCounter = ({ title }) => {
    const [installs, setInstalls] = useState(0);

    useEffect(() => {
        const fetchInstalls = async () => {
            try {
                const response = await fetch(
                    `${FUNCTIONS_URL}/google-store-info/installs`
                );
                if (!response.ok) throw new Error(`HTTP error ${response.status}`);
                const result = await response.json();
                setInstalls(result.maxInstalls);
            } catch (error) {
                console.error('Failed to fetch installs:', error);
                setInstalls(0);
            }
        };

        fetchInstalls();
    }, []);

    return (
        <div className={className('pregnancy-header-counter')}>
            <h4 className={className('pregnancy-header-counter-text')}>
                <CountUp
                    isCounting={true}
                    end={installs * 2 + 62000}
                    duration={3}
                    thousandsSeparator=" "
                    easing={easeOutExpo}
                />
            </h4>
            <h4 className={className('pregnancy-header-counter-install')}>
                {title}
            </h4>
        </div>
    )
}

export default PregnancyCounter
